<div class="app_modal__ligthBox"></div>
<section [ngSwitch]="modalType" class="app_modal__container">
  <div  *ngSwitchCase="'cerrarExamen'" class="app_modal__content app_modal__content--cerrarExamen">
    <div class="app_modal__content__body">
      <h1>{{ dataOfModal.tittle }}</h1>
      <p [innerHtml]="dataOfModal.body"></p>
    </div>
    <div class="app_modal__content__buttons">
      <span (click)="secondaryButtonAction()">
        {{ dataOfModal.textSecondaryButton }}
      </span>
      <button (click)="primaryButtonAction()">
        {{ dataOfModal.textPrincipalButton }}
      </button>
    </div>
  </div>

  <div class="app_modal__content" *ngSwitchCase="'agentesExposicion'">
    <app-exposure-agents></app-exposure-agents>
    <div class="app_modal__content__buttons">
      <span></span>
      <button (click)="primaryButtonAction()">
        Regresar al examen
      </button>
      </div>
  </div>

  <div  *ngSwitchCase="'cancelarExamen'" class="app_modal__content app_modal__content--cerrarExamen">
    <div class="app_modal__content__body">
      <h1>{{ dataOfModal.tittle }}</h1>
      <p [innerHtml]="dataOfModal.body"></p>
    </div>
    <div class="app_modal__content__buttons">
      <span (click)="secondaryButtonAction()">
        {{ dataOfModal.textSecondaryButton }}
      </span>
      <button (click)="primaryButtonAction()">
        {{ dataOfModal.textPrincipalButton }}
      </button>
    </div>
  </div>

</section>
